import { deletePolicyType } from "@/api/policy-types";
import { DestructiveDialog } from "@/components/shared/dialogs/destructive-dialog/DestructiveDialog";
import { DestructiveDialogProps } from "@/components/shared/dialogs/destructive-dialog/DestructiveDialog.types";
import { Delete } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { useQueryClient } from "@tanstack/react-query";
import { useDialogs } from "@toolpad/core";

interface IProps {
    policyTypeId: number;
}

export const DeletePolicyTypeButton = ({ policyTypeId }: IProps) => {
    const dialogs = useDialogs();
    const queryClient = useQueryClient();

    const dialogProps: DestructiveDialogProps = {
        itemId: policyTypeId,
        subject: "policy type",
        mutationFn: deletePolicyType,
        onSucceeded: () => {
            queryClient.invalidateQueries({
                queryKey: ["admin-policy-types"],
            });
        },
    };

    const handleDelete = async () => {
        await dialogs.open(DestructiveDialog, dialogProps);
    };

    return (
        <GridActionsCellItem
            icon={
                <Tooltip title="Delete Policy Type">
                    <Delete />
                </Tooltip>
            }
            label="Delete"
            onClick={handleDelete}
        />
    );
};
